<template>
  <div class="summary">

    <ul class="summary__header">
      <li class="summary__title">
        {{chartTitle}}
      </li>
      <li class="summary__tools">
        <el-button type="text" class="summary__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="summary__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="summary__card" v-loading="pending">
      <summary-header :chart-name="name" />

      <summary-body
        :data="data"
        :chart-name="name"
        :save-chart="saveChart"
        :title="chartTitle"
        @onSavedChart="handleSaved"
        @onSaveChart="handleSave"
      />
    </el-card>

  </div>
</template>

<script>
  // mixins
  import { audit } from "../../../../../../../mixins/audit";

  // components
  import SummaryHeader from "./header/SummaryLikesAndRepostsHeader";
  import SummaryBody from "./body/SummaryLikesAndRepostsBody";

  export default {
    name: "SummaryLikesAndReposts",
    data() {
      return {
        name: "SummaryLikesAndReposts",
        saveChart: false,
        chartTitle: this.$t('feed.audit.likesAndReposts.title')
      };
    },
    components: {
      SummaryHeader,
      SummaryBody
    },
    mixins: [
      audit
    ],
  }
</script>

<style>
  .summary__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .summary__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .summary__tools .material-icons {
    font-size: 16px;
  }

  .summary__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .summary__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .summary__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }

  .summary__card {
    margin-bottom: 20px;
  }
</style>
